import { jsx as a, jsxs as o, Fragment as L } from "react/jsx-runtime";
import { BREAKPOINTS as h } from "@fcamna/shared-component-foundations";
import { c as W } from "./index-65016bfa.mjs";
import t, { css as r } from "styled-components";
import "react";
import { u as $ } from "./useQuantum-50e8fd44.mjs";
import "./isClient-ec947a14.mjs";
import "./useSlots-a1aa6a84.mjs";
import { u } from "./useWindowSize-88e90e04.mjs";
import { h as s } from "./hTag-27bb1617.mjs";
import { Image as f } from "./image.js";
import { c as x } from "./childrenCountCheck-785fa19a.mjs";
import "./setup-0f23222d.mjs";
import "./table.js";
import "./uniqueId-321287e8.mjs";
import "./_commonjsHelpers-92157f1b.mjs";
import "./aspectRatio.js";
import "./mediaDisclosureButton.js";
import "react-dom";
const I = t.div`
  ${({
  theme: {
    components: { marketingDataList: e }
  }
}) => r(e.MarketingListItemWrapper)};
`, T = t.div`
  ${({
  theme: {
    components: { marketingDataList: e }
  }
}) => r(e.ValueTextWrapper)};
`, v = t(s)`
  ${({
  theme: {
    components: { marketingDataList: e }
  }
}) => r(e.Value)};
`, S = t.span`
  ${({
  theme: {
    components: { marketingDataList: e }
  }
}) => r(e.Text)};
`, b = ({ value: e, description: n, headingLevel: m, className: i }) => /* @__PURE__ */ a(I, { className: i, children: /* @__PURE__ */ o(T, { children: [
  e && /* @__PURE__ */ a(v, { as: m || "h2", children: e }),
  n && /* @__PURE__ */ a(S, { children: n })
] }) }), w = t.div`
  &.marketingDataList-mainWrapper {
    ${({
  theme: {
    componentStyles: e,
    components: { marketingDataList: n }
  }
}) => r(n.MainWrapper, e)};
  }
`, D = t.div`
  ${({
  theme: {
    components: { marketingDataList: e }
  }
}) => r(e.MarketingListItemSection)};
`, C = t.div`
  ${({
  theme: {
    components: { marketingDataList: e }
  }
}) => r(e.ImageWrapper)};
`, N = t.div`
  ${({
  theme: {
    components: { marketingDataList: e }
  }
}) => r(e.ChildrenWrapper)};
`, j = t.div`
  ${({
  theme: {
    components: { marketingDataList: e }
  }
}) => r(e.TitleSubTitleWrapper)};
`, V = t(s)`
  &.titleWrapper {
    ${({
  theme: {
    components: { marketingDataList: e }
  }
}) => r(e.TitleWrapper)};
  }
`, F = t(s)`
  ${({
  theme: {
    components: { marketingDataList: e }
  }
}) => r(e.SubTitleWrapper)};
`, z = ({
  children: e,
  className: n,
  titleProp: m,
  subTitleProp: i,
  imageProp: c,
  isImageRightAligned: p,
  dataTestId: g
}) => {
  const M = $({ label: "Marketing Data List" }), { width: k } = u(), l = u().width < h.tabletMin, d = () => /* @__PURE__ */ a(C, { children: /* @__PURE__ */ a(
    f,
    {
      ...c,
      ratio: k < h.tabletMin ? "3/2" : "1/1",
      objectFit: c.objectFit || "fill"
    }
  ) });
  return /* @__PURE__ */ o(L, { children: [
    x({
      additionalInfo: "Maximun data list items count exceeded. Max 6 list items allowed in a group for marketing data list.",
      children: e,
      componentName: "marketing data list",
      maxChildren: 6
    }),
    /* @__PURE__ */ o(
      w,
      {
        className: W([
          [
            `${n}`,
            "marketingDataList-mainWrapper",
            {
              "marketingDataList-mainWrapper--right": p
            }
          ]
        ]),
        "data-testid": g,
        ...M,
        children: [
          (!p || l) && d(),
          /* @__PURE__ */ o(D, { children: [
            /* @__PURE__ */ o(j, { children: [
              m && /* @__PURE__ */ a(
                V,
                {
                  as: m.headingLevel,
                  className: W(["titleWrapper", `titleWrapper--${m.size || "extraLarge"}`]),
                  children: m.title
                }
              ),
              (i == null ? void 0 : i.subTitle) && /* @__PURE__ */ a(F, { as: i.headingLevel || "h2", children: i.subTitle })
            ] }),
            /* @__PURE__ */ a(N, { children: e })
          ] }),
          p && !l && d()
        ]
      }
    )
  ] });
};
z.Item = b;
export {
  z as MarketingDataList
};
